module.exports = __webpack_public_path__ + "static/media/pks_background.0652edd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/pks_background.png
// module id = 2594
// module chunks = 0